<template>
    <div>
        <topnav :toptype="toptype"></topnav>
        <div class=" animated fadeInUp" style="background: #eef1fa;padding-top: 30px;min-height: 600px;">
            <div v-if="detail" class="marginauto" style="width: 1145px;">
                <div class="bg-white" style="width: 945px;padding: 20px 100px 50px 100px;border-radius: 10px;">
                    <div class="sd_title">
                        <p class="biaoti1">{{detail.name}}</p>
                        <p class="bt_mes" style="margin-bottom: 0;">
                            活动时间：{{detail.active_time}}
                        </p>
                        <p class="bt_mes" style="margin-top: 0;">
                            活动地址：{{detail.address}}
                        </p>
                    </div>
                    <div class="sd_content padding-top">
                        <div v-if="detail.content" class="" v-html="detail.content"></div>
                        <el-empty v-if="!detail.content" description="暂无详细介绍"></el-empty>
                    </div>
                </div>
            </div>
            <!-- <div v-if="detail" @click="shownow" class="new_bot flex justify-center align-center pointer">
                <div class="bot_text">{{config.train_detail ? config.train_detail : ''}}</div>
                <div class="bot_btn">立即获取</div>
            </div> -->
        </div>

        <callview :text="config.train_detail" ></callview>
        <!-- <el-dialog title="咨询" :visible.sync="addcompany">
            <div class="" style="text-align: center;width: 60%;margin: 0 auto;">
                <el-form :model="cominfo" style="text-align:center;">
                <el-form-item label="姓名" :label-width="formLabelWidth">
                    <el-input style="width: 420px;" placeholder="请输入" v-model="cominfo.name" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item label="电话" :label-width="formLabelWidth">
                    <el-input style="width: 420px;" placeholder="请输入" v-model="cominfo.phone" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item label="咨询内容" :label-width="formLabelWidth">
                    <el-input type="textarea" :rows="2" style="width: 420px;" placeholder="请输入咨询内容" v-model="cominfo.content" autocomplete="off"></el-input>
                </el-form-item>

                </el-form>
            </div>
            
            <div slot="footer" class="flex justify-center align-center">
                <el-button :disabled="nowdisabled" @click="tosub" type="primary" >提 交</el-button>
            </div>
        </el-dialog>   -->
    </div>
</template>
<script>
import { mapGetters } from "vuex";
export default {
    computed: {
        ...mapGetters(["token"]),
    },
    data() {
        return {
            id: "",
            toptype: 5,
            type: 0,
            detail: "",
            addcompany: false,
            formLabelWidth: "120px",
            nowdisabled: false,
            cominfo: {
                question_id: "",
                type: 4,
                company_name: "",
                name: "",
                phone: "",
                content: "",
                user_id: "",
            },
            config: "",
        };
    },
    methods: {
        getconfig() {
            this.$api.index.config().then((res) => {
                this.config = res.data;
            });
        },
        toopen(file) {
            var domain = this.detail.domain;
            window.open(domain + file);
        },
        getdetail() {
            this.$api.index.train_detail({ id: this.id }).then((res) => {
                var regex = new RegExp("<img", "gi");
                res.data.content = res.data.content.replace(
                    regex,
                    `<img style="max-width: 100%;height: auto"`
                );
                this.detail = res.data;
            });
        },
        tosub() {
            // question_add
            if (
                !this.cominfo.content ||
                !this.cominfo.phone ||
                !this.cominfo.name
            ) {
                this.$message({
                    message: "请完善信息",
                    type: "warning",
                    duration: 1000,
                });
                return false;
            }
            if (!this.cominfo.phone) {
                this.$message({
                    message: "请输入手机号",
                    type: "warning",
                    duration: 1000,
                });
                return false;
            }
            if (!/^1[3456789]\d{9}$/.test(this.cominfo.phone)) {
                this.$message({
                    message: "手机号码错误！",
                    type: "warning",
                    duration: 1000,
                });
                return false;
            }
            this.cominfo.user_id = this.token;
            this.nowdisabled = true;
            this.$api.index
                .question_add(this.cominfo)
                .then((res) => {
                    console.log(res);
                    this.$message({
                        message: res.msg,
                        type: "none",
                        duration: 1000,
                    });
                    this.addcompany = false;
                    this.cominfo.phone = "";
                    this.cominfo.name = "";
                    this.cominfo.content = "";
                    this.nowdisabled = false;
                })
                .catch(() => {
                    this.nowdisabled = false;
                });
        },
        shownow() {
            if (!this.token) {
                this.$message.error("请登录");
                return false;
            }
            this.addcompany = true;
            this.cominfo.question_id = this.detail.id;
        },
    },
    created() {
        this.id = this.$route.query.id;
        this.getconfig();
        this.getdetail();
    },
};
</script>
<style scoped>
.sd_title {
    text-align: center;
    border-bottom: 1px solid #eee;
}

.biaoti1 {
    font-size: 32px;
    color: #202020;
    line-height: 42px;
}

.bt_mes {
    font-size: 15px;
    color: #7f7f7f;
    line-height: 35px;
    margin-bottom: 20px;
}
.filecolor {
    color: blue;
}
.new_bot {
    width: 100%;
    height: 70px;
    background-image: linear-gradient(
        0deg,
        #1759d8 0%,
        #107ee4 56%,
        #08a3f0 100%
    );
    margin-top: 30px;
}
.bot_text {
    color: #ffffff;
    font-size: 22px;
}
.bot_btn {
    width: 144px;
    height: 44px;
    background-image: linear-gradient(0deg, #ece2ae 0%, #fffef4 100%);
    border-radius: 22px;
    color: #b97a00;
    line-height: 44px;
    font-size: 20px;
    text-align: center;
    margin-left: 50px;
}
</style>


// WEBPACK FOOTER //
// traindetail.vue?073d86ac